import { replaceRichTextLinks } from "@/utils/replaceRichTextLinks"
import styled from "@emotion/styled"
import { Checkbox, FormControl, FormControlLabel } from "@mui/material"
import { FormFieldDto } from "api"
import { Controller, FieldError } from "react-hook-form"
import { colors } from "ui"
import { StyledHelperText } from "../StyledComponents"

interface Props {
  field: FormFieldDto
  control: any
  error: FieldError | undefined
  isSubmitted: boolean
  fieldName?: string // Add optional fieldName prop
}

const StyledCheckboxDescription = styled.div`
  color: ${colors.black};
  p {
    color: ${colors.black};
    margin-top: 0;
  }
`

const StyledCheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

const CheckboxField = ({
  field,
  control,
  error,
  isSubmitted,
  fieldName,
}: Props) => {
  const actualFieldName = fieldName || field.id // Use fieldName if provided, fallback to field.id

  return (
    <FormControl fullWidth error={!!error}>
      <StyledCheckboxContainer>
        <FormControlLabel
          sx={{ marginRight: "0px" }}
          control={
            <Controller
              name={actualFieldName}
              control={control}
              defaultValue={false}
              render={({ field: { onChange, value } }) => (
                <Checkbox
                  id={actualFieldName}
                  checked={!!value}
                  onChange={(e) => onChange(e.target.checked)}
                  sx={{
                    color: colors.gray,
                    "&.Mui-checked": {
                      color: colors.blue,
                    },
                    "&.MuiFormControl-root": {
                      display: "flex",
                      flexDirection: "row",
                    },
                    flexDirection: "row",
                  }}
                  inputProps={{
                    "aria-invalid": !!error,
                    "aria-describedby": `${actualFieldName}-helper-text`,
                  }}
                />
              )}
            />
          }
          label={undefined}
        />
        <StyledCheckboxDescription
          dangerouslySetInnerHTML={{
            __html: replaceRichTextLinks(
              field.helpText ||
                (typeof field.settings === "object"
                  ? field.settings?.richTextContent
                  : field.settings) ||
                "",
            ),
          }}
        />
      </StyledCheckboxContainer>
      <StyledHelperText
        id={`${actualFieldName}-helper-text`}
        status={!error}
        marginTop={"-7px"}
      >
        {isSubmitted && error && (
          <>
            {/* <CheckMark2Icon state={!error} /> */}
            <span>{error?.message as string}</span>
          </>
        )}
      </StyledHelperText>
    </FormControl>
  )
}

export default CheckboxField
